<script lang="ts" setup>
const props = defineProps<{ price: number; className?: string }>();

const documentLang = globalThis.document.documentElement.lang ?? 'nl';

// Format price for the user locale, we can safely assume it is in EUR and passed as cents
const formattedPrice = new Intl.NumberFormat(documentLang, {
  style: 'currency',
  currency: 'EUR',
}).format(props.price / 100);
</script>

<template>
  <bdi :class="className">{{ formattedPrice }}</bdi>
</template>
